var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { retryAuthentication } from "@/app/integration/microsoft";
import { showBanner } from "@/app/utils/AlertBannerUtils";
import { STORE } from "@/store";
import { SERVICE } from "@agentx/agentx-services";
import { Router } from "@uuip/unified-ui-platform";
import { customElement, html } from "lit-element";
import { MobxLitElement } from "@adobe/lit-mobx";
import { nothing } from "lit-html";
import style from "./InteractionsDetailsBlock.scss";
/**
 * @element agentx-interactions-control-wrapper
 */
let InteractionsControlWrapper = class InteractionsControlWrapper extends MobxLitElement {
    render() {
        return html `${STORE.interactions.selectedInteraction ? this.renderInteractionControl() : nothing}`;
    }
    renderInteractionControl() {
        return html `<agentx-react-interaction-control-wrapper
      isDesktopConsultToEntryPointDnEnabled=${STORE.app.featureFlags.isDesktopConsultToEntryPointDnEnabled}
      isAddressBookInfiniteScrollEnabled=${STORE.app.featureFlags.isAddressBookInfiniteScrollEnabled}
      isDesktopConferenceRecordingEnabled=${STORE.app.featureFlags.isDesktopConferenceRecordingEnabled}
      isDesktopAuxCodesInfiniteScrollEnabled=${STORE.app.featureFlags.isDesktopAuxCodesInfiniteScrollEnabled}
      isDarkMode="${STORE.app.darkMode}"
      .epDnMapping=${STORE.selectedInteraction.epDnMapping}
      .addressBook=${STORE.selectedInteraction.addressBook}
      .interaction="${STORE.selectedInteraction.interaction}"
      .isCallMuted="${STORE.selectedInteraction.isCallMuted}"
      .agentconfig="${STORE.selectedInteraction.agentConfig}"
      .cadStatus="${STORE.selectedInteraction.cadStatus}"
      .wrapUpData="${STORE.selectedInteraction.wrapUpData}"
      .agentWrapUpCodeProps="${STORE.selectedInteraction.agentWrapUpCodeProps}"
      .callpersistence="${STORE.selectedInteraction.callpersistence}"
      ?isVoiceInteraction="${STORE.selectedInteraction.isVoiceInteraction}"
      .isVoiceIntPaneUpdatedByUser="${STORE.app.isVoiceIntPaneUpdatedByUser}"
      .currentRoute="${STORE.routing.currentRouteName}"
      @ax-update-uservoiceIntPaneState="${(e) => {
            STORE.app.updateUserVoiceIntPaneState(e.detail);
        }}"
      isProgressiveCampaignEnabled="${STORE.app.featureFlags.isProgressiveCampaignEnabled}"
      isProgressiveCampaign1NEnabled="${STORE.app.featureFlags.isProgressiveCampaign1NEnabled}"
      @ax-interaction-wrapup="${(e) => {
            STORE.agent.updateStatusAfterOutdial(e);
            STORE.session.screenpop.updateScreenPopData(e.detail.interactionIdParam);
            STORE.session.interactionControl.removeInteraction(e.detail.interactionIdParam);
        }}"
      @ax-main-cad-section-dimension="${(e) => {
            setTimeout(() => {
                STORE.agentContact.updateCadSectionDimension("mainCallContainerHeight", e.detail.height);
            }, 0);
        }}"
      @ax-consult-cad-section-dimension="${(e) => {
            setTimeout(() => {
                STORE.agentContact.updateCadSectionDimension("consultCallContainerHeight", e.detail.height);
            }, 0);
        }}"
      @ax-auto-wrap-up="${(e) => {
            STORE.session.interactionControl.removeInteraction(e.detail.interactionId);
        }}"
      @ax-interaction-recording-pause-failed="${(e) => {
            STORE.session.errorModal.setErrorDetails(e);
        }}"
      @ax-interaction-recording-resume-failed="${(e) => {
            STORE.session.errorModal.setErrorDetails(e);
        }}"
      @ax-interaction-hold-failed="${(e) => {
            STORE.session.errorModal.setErrorDetails(e);
        }}"
      @ax-interaction-resume-failed="${(e) => {
            STORE.session.errorModal.setErrorDetails(e);
        }}"
      @ax-interaction-end-failed="${(e) => {
            STORE.session.errorModal.setErrorDetails(e);
        }}"
      @ax-interaction-consult-transfer="${() => {
            STORE.agentContact.resetInteractionControlDimensions();
        }}"
      @ax-interaction-consult-transfer-failed="${(e) => {
            STORE.session.errorModal.setErrorDetails(e);
        }}"
      @ax-interaction-conference-transfer-failed="${(e) => {
            STORE.session.errorModal.setErrorDetails(e);
        }}"
      @ax-interaction-consult-end-failed="${(e) => {
            STORE.session.errorModal.setErrorDetails(e);
        }}"
      @ax-interaction-conference-end-failed="${(e) => {
            STORE.session.errorModal.setErrorDetails(e);
        }}"
      @ax-interaction-conference-exit-failed="${(e) => {
            STORE.session.errorModal.setErrorDetails(e);
        }}"
      @ax-interaction-conference-failed="${(e) => {
            STORE.session.errorModal.setErrorDetails(e);
        }}"
      @ax-update-navigation-warning="${(e) => {
            STORE.agentContact.updateWarnOnNavigation(e.detail);
        }}"
      @ax-reset-warn-on-navigation="${() => {
            STORE.agentContact.resetWarningOnNavigation();
        }}"
      @ax-interaction-modal-toggled=${(e) => {
            STORE.common.updateInteractionModalState(e.detail);
        }}
      @ax-interaction-fetch-epdn-list-success=${(e) => {
            STORE.agent.updateEpDnList(e.detail.data);
        }}
      @ax-interaction-fetch-epdn-list-failure=${(e) => {
            STORE.agent.updatetrackingIdforEpList(e.detail.error);
        }}
      @ax-interaction-fetch-addressbook-list-success=${(e) => {
            STORE.agent.updateAddressbookList(e.detail.data);
        }}
      @ax-interaction-fetch-addressbook-list-failure=${(e) => {
            STORE.agent.updateAddressbookListFailed(e.detail);
        }}
      @ax-interaction-monitoring-hold-failed="${(e) => {
            STORE.session.errorModal.setErrorDetails(e);
        }}"
      @monitor-interaction-owner="${(e) => {
            STORE.agentContact.setMonitoringOwnerName(e.detail);
        }}"
      @ax-update-dtmf-value="${(e) => {
            STORE.agent.updateDtmfValue(e.detail.value);
        }}"
      @ax-fire-notification="${(e) => {
            STORE.generalNotifications.fireNotificationEvent(e.detail);
            STORE.browserNotifications.firebrowserNotification(e.detail.data);
        }}"
      @ax-end-monitoring="${(e) => {
            STORE.agentContact.setIsMonitoringNotEndedManually(e.detail);
        }}"
      @ax-banner-show="${(e) => {
            showBanner(e);
        }}"
      @initiate-microsoft-auth-flow="${() => {
            retryAuthentication();
        }}"
      @ax-wrapup-codes-update="${(e) => {
            STORE.agent.updateAgentWrapUpCodes(e.detail);
            SERVICE.conf.updateWrapUpCodeConfig(e.detail);
        }}"
    ></agentx-react-interaction-control-wrapper>`;
    }
};
InteractionsControlWrapper = __decorate([
    customElement("agentx-interactions-control-wrapper")
], InteractionsControlWrapper);
export { InteractionsControlWrapper };
const InteractionsDetailsBlock = () => {
    return new Router.RouterView.Block({
        template: html `
      <div class="details-view">
        <agentx-wc-interactions-tab-details-widget
          .interactionsStore=${STORE.interactions}
          @interactions-details-close=${() => {
            STORE.layout.setRouterViewClasses({ expanded: false });
        }}
        >
          <agentx-interactions-control-wrapper slot="top-panel-content"></agentx-interactions-control-wrapper>
        </agentx-wc-interactions-tab-details-widget>
      </div>
    `,
        styles: [style]
    });
};
export default InteractionsDetailsBlock;
